import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { EntityType, Area, Host, OS, Platform, IAnalyticsV2Filters } from "../abstractions/IAnalyticsFilters"
import { Capability } from "../charts";

interface IAnalyticsFilterState {
    isVisible: boolean;
    filters: IAnalyticsV2Filters
}


export const intitalFilterState: IAnalyticsV2Filters = {
    entityType: EntityType.User,
    area: Area.AllUp,
    host: Host.AllUp,
    capability: Capability.AllUp,
    os: OS.AllUp,
    platform: Platform.AllUp,
};

export const initialState: IAnalyticsFilterState = {
    isVisible: false,
    filters: {
        entityType: EntityType.User,
        area: Area.AllUp,
        host: Host.AllUp,
        capability: Capability.AllUp,
        os: OS.AllUp,
        platform: Platform.AllUp,
    }
};

export const analyticsFilterSlice = createSlice({
    name: "analyticsFilter",
    initialState,
    reducers: {
        updatedAnalyticsFilter: (state, { payload }: PayloadAction<IAnalyticsV2Filters>) => //state.filters = payload,
        {
            state.filters = payload;
            return state;
        },
        resetAnaylticsFilter: (state) => {
            state.filters = initialState.filters;
            return state;
        },
        setFilterVisibility: (state, { payload }: PayloadAction<boolean>) => {
            state.isVisible = payload
            return state
        },
    }
});